var _defs, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLeftNavigationStreamingIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 31 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5849a6;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.3,15.5v-6.1c0-.8-.6-1.4-1.4-1.4h-6.1c-.8,0-1.5.7-1.5,1.5s.7,1.5,1.5,1.5h2.4l-8.5,8.5-4.9-4.9c-.7-.7-1.7-.7-2.4,0l-5.9,6.1V2c0-.8-.7-1.5-1.5-1.5S.7,1.2.7,2v27.1c0,.8.6,1.4,1.4,1.4h26.8c.8,0,1.5-.7,1.5-1.5s-.7-1.5-1.5-1.5H3.6v-2.4l7.1-7.5,4.9,5c.7.7,1.7.7,2.4,0l9.4-9.5v2.4c0,.8.7,1.5,1.5,1.5s1.5-.7,1.5-1.5h0Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeftNavigationStreamingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/leftNavigationStreamingIcon.4517eda5.svg";
export { ForwardRef as ReactComponent };